import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import {BlackMask} from '../../../../../../components/mask'

export default props => {
    useStyles(classes)
    return <>
        <BlackMask style={{zIndex: 11}}/>
        <div className={classes.Paying}>
            <div className={classes.Image}>
                <img src="https://image.geeko.ltd/chicme/20220706/paying.gif" alt="loading" />
            </div>
            <div className={classes.Content}>
                <div>
                    <FormattedMessage id="process_payment" defaultMessage="We are processing your payment"/>
                </div>
                <div>
                    <FormattedMessage id="do_not_leave_refresh" defaultMessage="Please do not leave or refresh"/>
                </div>
            </div>
        </div>
    </>
}